// @flow
import xws from 'api/xws/';
import type { AxiosPromise } from 'axios';
import type { Dispatch } from 'types/redux';

// Constants
import { getService } from 'constants/ajax';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';

type AdvisorInfo = {|
  name: string,
  phoneNo: number,
  email: string
|};

export type VehicleInfo = {|
  year: number | null,
  make: string | null,
  model: string | null
|};

type DealerContact = {|
  city: string,
  country: string,
  districtId: string,
  partsPhone: string,
  postalCodeString: string,
  salesPhone: string | number,
  servicePhone: string | number,
  state: string,
  streetAddressOne: string,
  streetAddressTwo: string
|};

export type StatusTrackerResponse = {|
  reservationId: number,
  confirmationKey: string,
  status: string,
  advisorInfo: AdvisorInfo,
  vehicleInfo: VehicleInfo,
  dealerContact: DealerContact,
  defaultDealerMake: string
|};

export function statusTrackerWs(
  reservationId: number,
  dispatch: Dispatch,
  params: Object
): AxiosPromise<null, StatusTrackerResponse> {
  try {
    const statusTrackerService = getService('statusTracker');
    statusTrackerService.setPathVars({ reservationId });
    statusTrackerService.setCallBacks(dispatch(ajaxCallbacks()));
    return xws(statusTrackerService).get(statusTrackerService.getPath(), {
      params
    });
  } catch (e) {
    /* eslint-disable no-console */
    console.log(e);
    /* eslint-enable no-console */
    throw new Error(e);
  }
}



// WEBPACK FOOTER //
// ./src/api/xws/statusTracker/statusTrackerWs.js